import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Dashboard from '../views/Dashboard'
import DashboardLayout from "@/pages/Layout/DashboardLayout"
import UserProfile from "@/pages/UserProfile.vue";
import TableList from "@/pages/TableList.vue";
import Typography from "@/pages/Typography.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Notifications from "@/pages/Notifications.vue";
import UpgradeToPRO from "@/pages/UpgradeToPRO.vue";
import Listings from "@/pages/Listings";
import ChannelManager from "@/pages/ChannelManager";
import CreateListing from "@/pages/CreateListing";
import ListingDetails from "@/pages/ListingDetails";
import BookingPayment from "@/pages/payment/BookingPayment";
import Integrations from "@/pages/payment/Integrations";
import Reservations from "@/pages/reservations/Reservations";
import ReservationDetails from "@/pages/reservations/ReservationDetails";
import BookNow from "@/pages/reservations/BookNow";
import EditListing from "@/pages/EditListing";
import MainAdmin from "@/pages/admin/MainAdmin";
import AdminLayout from "@/pages/Layout/AdminLayout";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminBlocked from "@/pages/admin/AdminBlocked";
import AdminTags from "@/pages/admin/AdminTags";
import PrivacyPolicy from "@/views/PrivacyPolicy";
import TermsOfUse from "@/views/TermsOfUse";
import CookiePolicy from "@/views/CookiePolicy";
import AdminContacts from "@/pages/admin/AdminContacts";
import Drafts from "@/pages/Drafts";
import AdminSubscribes from "@/pages/admin/AdminSubscribes";
import AdminAmenities from "@/pages/admin/AdminAmenities";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {auth: false}
  },
  {
    path: '/sign_in',
    name: 'SignIn',
    component: () => import(/* webpackChunkName: "sign_in" */ '../views/auth/SignIn'),
    meta: {auth: false}
  },
  {
    path: '/sign_up',
    name: 'SignUp',
    component: () => import(/* webpackChunkName: "sign_up" */ '../views/auth/SignUp'),
    meta: {auth: false}
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "forgot_password" */ '../views/auth/ForgotPassword'),
    meta: {auth: false}
  },
  {
    path: '/check',
    name: 'Check',
    component: () => import(/* webpackChunkName: "check" */ '../views/auth/Check'),
    meta: {auth: false}
  },
  {
    path: '/reset-password',
    name: 'Reset',
    component: () => import(/* webpackChunkName: "reset" */ '../views/auth/Reset'),
    meta: {auth: false}
  },
  {
    path: '/contact_us',
    name: 'ContactUs',
    component: () => import(/* webpackChunkName: "contact_us" */ '../views/ContactUs'),
    meta: {auth: false}
  },
  {
    path: '/about_us',
    name: 'AboutUs',
    component: () => import(/* webpackChunkName: "about_us" */ '../views/AboutUs'),
    meta: {auth: false}
  },
  {
    path: '/listing_calendar',
    name: 'ListingCalendar',
    component: () => import(/* webpackChunkName: "about_us" */ '../views/ListingCalendar'),
    meta: {auth: false}
  },
  {
    path: '/blogs',
    name: 'AllBlogs',
    component: () => import(/* webpackChunkName: "blog" */ '../views/AllBlogs'),
    meta: {auth: false}
  },
  {
    path: '/blog/:id',
    name: 'Blog',
    component: () => import(/* webpackChunkName: "blog" */ '../views/Blog'),
    meta: {auth: false},
    props: true,
  },
  {
    path: '/category_listings',
    name: 'CategoryListings',
    component: () => import(/* webpackChunkName: "blog" */ '../views/CategoryListings'),
    meta: {auth: false},
    props: true,
  },
  {
    path: "/reservation/:unique_hash",
    name: "ReservationDetails",
    component: ReservationDetails,
    props: true,
    meta: {auth: false}
  },
  {
    path: "/book_now",
    name: "BookNow",
    component: BookNow,
    meta: {auth: false}
  },
  {
    path: "/privacy_policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: {auth: false}
  },
  {
    path: "/terms_of_use",
    name: "TermsOfUse",
    component: TermsOfUse,
    meta: {auth: false}
  },
  {
    path: "/cookie_policy",
    name: "CookiePolicy",
    component: CookiePolicy,
    meta: {auth: false}
  },

  {
    path: '/dashboard',
    redirect: "/dashboard",
    component: DashboardLayout,
    meta: {layout: 'dashboard', auth: true, type: 0},
    children: [
      // {
      //   path: "/dashboard",
      //   name: "Dashboard",
      //   component: Dashboard,
      //   meta: {layout: 'dashboard', auth: true, type: 0},
      // },
      // {
      //   path: "/listings",
      //   name: "Listings",
      //   component: Listings,
      //   meta: {layout: 'dashboard', auth: true, type: 0},
      // },
      // {
      //   path: "/drafts",
      //   name: "Drafts",
      //   component: Drafts,
      //   meta: {layout: 'dashboard', auth: true, type: 0},
      // },
      // {
      //   path: "/listing_details/:id",
      //   name: "ListingDetails",
      //   component: ListingDetails,
      //   props: true,
      //   meta: {layout: 'dashboard', auth: true, type: 0},
      // },
      // {
      //   path: "/create_listing",
      //   name: "CreateListing",
      //   component: CreateListing,
      //   meta: {layout: 'dashboard', auth: true, type: 0},
      // },
      // {
      //   path: "/edit_listing/:id",
      //   name: "EditListing",
      //   component: EditListing,
      //   meta: {layout: 'dashboard', auth: true, type: 0},
      // },
      // {
      //   path: "/integrations",
      //   name: "Integrations",
      //   component: Integrations,
      //   meta: {layout: 'dashboard', auth: true, type: 0},
      // },
      // {
      //   path: "/payment",
      //   name: "BookingPayment",
      //   component: BookingPayment,
      //   meta: {layout: 'dashboard', auth: true, type: 0},
      // },
      // {
      //   path: "/reservations",
      //   name: "Reservations",
      //   component: Reservations,
      //   meta: {layout: 'dashboard', auth: true, type: 0},
      // },


      {
        path: "/channel_manager",
        name: "ChannelManager",
        component: ChannelManager,
      },
    
      {
        path: "/table",
        name: "Table List",
        component: TableList,
      },
      {
        path: "/typography",
        name: "Typography",
        component: Typography,
      },
      {
        path: "/icons",
        name: "Icons",
        component: Icons,
      },
      {
        path: "/maps",
        name: "Maps",
        meta: {
          hideFooter: true,
        },
        component: Maps,
      },
      {
        path: "/notifications",
        name: "Notifications",
        component: Notifications,
      },
      {
        path: "/upgrade",
        name: "Upgrade to PRO",
        component: UpgradeToPRO,
      },
    ]
  },
  {
    path: '/admin',
    redirect: "/admin",
    component: AdminLayout,
    meta: {layout: 'admin', auth: true, type: 1},
    children: [
      {
        path: "/admin",
        name: "MainAdmin",
        component: MainAdmin,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/user",
        name: "User Profile",
        component: UserProfile,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/blogs",
        name: "AdminBlogs",
        component: AdminBlogs,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/reviews",
        name: "AdminReviews",
        component: AdminReviews,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/subscribes",
        name: "AdminSubscribes",
        component: AdminSubscribes,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/contacts",
        name: "AdminContacts",
        component: AdminContacts,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/blocked_contacts",
        name: "AdminBlockedContacts",
        component: AdminBlocked,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/tags",
        name: "AdminTags",
        component: AdminTags,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/amenities",
        name: "AdminAmenities",
        component: AdminAmenities,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/create_listing",
        name: "CreateListing",
        component: CreateListing,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/listings",
        name: "Listings",
        component: Listings,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/drafts",
        name: "Drafts",
        component: Drafts,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/listing_details/:id",
        name: "ListingDetails",
        component: ListingDetails,
        props: true,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/edit_listing/:id",
        name: "EditListing",
        component: EditListing,
        props: true,
        meta: {layout: 'admin', auth: true, type: 1},
      },
      {
        path: "/admin/reservations",
        name: "Reservations",
        component: Reservations,
        meta: {layout: 'admin', auth: true, type: 1},
      },
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "sign_in" */ '../views/PageNotFound'),
    meta: {auth: false}
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if(to.meta.auth && !store.getters['accessToken']) {
    store.commit('clearUserData')
    return next({name: 'SignIn'})
  }
  
  if(to.meta.auth && to.meta.type !== undefined) {
    let user = null
    try {
      const userData = localStorage.getItem('logInUser')
      if(userData) {
        user = JSON.parse(userData)
      }
    } catch(e) {
      console.error('Error parsing user data:', e)
    }
    
    if(!user || user.is_admin === undefined || to.meta.type !== user.is_admin) {
      return next({name: '404'})
    }
  }
  
  return next()
});

export default router
